const {
  VITE_APP_ENV: APP_ENV,
  VITE_APP_BASE_URL: BASE_URL,
  VITE_SUPPORT_URL: SUPPORT_URL,
  VITE_SKILLWEB_HOST: SKILLWEB_HOST,
  VITE_LAUNCH_DARKLY_CLIENT_ID: LAUNCH_DARKLY_CLIENT_ID,
  VITE_SENTRY_DSN: SENTRY_DSN,
  VITE_NODE_ENV: NODE_ENV,
  VITE_BUILD_VERSION: BUILD_VERSION,
  VITE_BUILD_TIME: BUILD_TIME,
  VITE_SKILL_EXTERNAL_CATALOG_URL: SKILL_EXTERNAL_CATALOG_URL,
  VITE_VIACEP_BASE_URL: VIACEP_BASE_URL,
  VITE_IFRAME_RESIZER_KEY: IFRAME_RESIZER_KEY,
  VITE_RECAPTCHA_ENABLED: RECAPTCHA_ENABLED,
  VITE_RECAPTCHA_SITE_KEY_V3: RECAPTCHA_SITE_KEY_V3,
  VITE_IDLE_CANCELLATION_KNOW_MORE_URL: IDLE_CANCELLATION_KNOW_MORE_URL
} = import.meta.env

export const settings = {
  BUILD_VERSION,
  BUILD_TIME: new Date(BUILD_TIME),
  NODE_ENV,
  APP_ENV,
  BASE_URL,
  SUPPORT_URL,
  SKILLWEB_HOST,
  LAUNCH_DARKLY_CLIENT_ID,
  SENTRY_DSN,
  SKILL_TERMS_OF_USE_URL:
    'https://unicoskill.zendesk.com/hc/pt-br/articles/45762192085140-Termos-de-uso-do-produto',
  SKILL_PRIVACY_POLICY_URL:
    'https://unicoskill.zendesk.com/hc/pt-br/articles/45761951997844-Aviso-de-Privacidade-Unico-Skill',
  SKILL_SOCIAL_MEDIA_LINKEDIN: 'https://www.linkedin.com/company/unicoskill/',
  SKILL_SOCIAL_MEDIA_INSTAGRAM: 'https://www.instagram.com/unico_skill',
  SKILL_EXTERNAL_CATALOG_URL,
  VIACEP_BASE_URL,
  IFRAME_RESIZER_KEY,
  // Espelha a property `recaptcha.enabled` do backend. Fail-safe: só desliga com o
  // valor explícito 'false' — variável ausente ou vazia mantém o reCAPTCHA ativo.
  // Não é controle de segurança: desligar aqui sem desligar no backend quebra o login
  // (MISSING_HEADER), e desligar nos dois remove a proteção anti-bot. É env em vez de
  // feature flag de propósito — o LaunchDarkly depende de rede e é bloqueável por
  // adblock, justamente a falha que este switch precisa contornar.
  RECAPTCHA_ENABLED: RECAPTCHA_ENABLED !== 'false',
  RECAPTCHA_SITE_KEY_V3,
  SKILL_EXPLORER_CATALOG_BASE_URL: 'https://cdn.skill.private.unico.run/skill-explorer-catalog',
  IDLE_CANCELLATION_KNOW_MORE_URL
}
